import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useCompany } from '../contexts/CompanyContext';
import { Loading } from './ui/atoms';
import toast from 'react-hot-toast';

export function SuperadminCompaniesGuard({ children }) {
  const navigate = useNavigate();
  const {
    isSuperadmin,
    isSuperadminOnOwnCompany,
    isLoadingCompanies,
    selectCompany,
    userCompanyId,
  } = useCompany();

  useEffect(() => {
    if (isLoadingCompanies || !isSuperadmin || !userCompanyId) {
      return;
    }

    if (!isSuperadminOnOwnCompany) {
      toast.error('Volte para sua empresa para gerenciar as empresas filhas.');
      selectCompany(userCompanyId);
      navigate('/');
    }
  }, [isLoadingCompanies, isSuperadmin, isSuperadminOnOwnCompany, navigate, selectCompany, userCompanyId]);

  if (!isSuperadmin) {
    return <Navigate to="/" replace />;
  }

  if (isLoadingCompanies) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <Loading />
      </div>
    );
  }

  if (!isSuperadminOnOwnCompany) {
    return null;
  }

  return children;
}
